import axios from 'axios';
import secureStorage from '../controllers/secureStorage.js';

axios.interceptors.request.use(
  function (config) {
    const source = secureStorage.getItem('source');
    // Do something before request is sent
    if (source && !config.url.includes('source')) {
      if (config.url.includes('?')) {
        config.url = config.url + `&source=${source}`;
      } else {
        config.url = config.url + `?source=${source}`;
      }
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

const HTTPRequest = {
  async getRequest(
    endPoint,
    parameters,
    token = secureStorage.getItem('bxiClpAccessToken')
  ) {
    let responseData;
    await axios({
      method: 'GET',
      url: endPoint,
      headers: {
        Authorization: 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*'
      },
      params: parameters
    })
      .then(function (response) {
        responseData = response.data;
      })
      .catch(function (error) {
        let errors = [];
        if (error.response.data.message != undefined) {
          errors.push(error.response.data.message);
        } else {
          if (error.response.statusText != undefined)
            errors.push(error.response.statusText);
          if (error.error != undefined) errors.push(error.error);
        }
        responseData = { error: errors.join(',') };
      });

    return responseData;
  },

  async postRequest(
    endPoint,
    requestBody,
    token = secureStorage.getItem('bxiClpAccessToken'),
    contentType = 'application/json'
  ) {
    let responseData;
    await axios({
      method: 'POST',
      url: endPoint,
      headers: {
        Authorization: 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': contentType
      },
      data: requestBody
    })
      .then(function (response) {
        responseData = response.data;
      })
      .catch(function (error) {
        console.log('catch: ', error);

        let errors = [];
        if (error.response.data.message != undefined) {
          if (error.response.data.message.toLowerCase() == 'validation error') {
            errors.push(error.response.data.errors[0].msg);
          } else {
            errors.push(error.response.data.message);
          }
        } else {
          if (error.response.statusText != undefined)
            errors.push(error.response.statusText);
          if (error.error != undefined) errors.push(error.error);
        }
        responseData = { error: errors.join(',') };
      });

    return responseData;
  },

  async putRequest(
    endPoint,
    requestBody,
    token = secureStorage.getItem('bxiClpAccessToken')
  ) {
    let responseData;
    await axios({
      method: 'PUT',
      url: endPoint,
      headers: {
        Authorization: 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*'
      },
      data: requestBody
    })
      .then(function (response) {
        responseData = response.data;
      })
      .catch(function (error) {
        let errors = [];
        if (error.response.data.message != undefined) {
          if (error.response.data.message == 'Validation error') {
            errors.push(error.response.data.errors[0].msg);
          } else {
            errors.push(error.response.data.message);
          }
        } else {
          if (error.response.statusText != undefined)
            errors.push(error.response.statusText);
          if (error.error != undefined) errors.push(error.error);
        }
        responseData = { error: errors.join(',') };
      });

    return responseData;
  },

  async deleteRequest(
    endPoint,
    requestBody,
    token = secureStorage.getItem('bxiClpAccessToken')
  ) {
    let responseData;
    await axios({
      method: 'DELETE',
      url: endPoint,
      headers: {
        Authorization: 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*'
      },
      data: requestBody
    })
      .then(function (response) {
        responseData = response.data;
      })
      .catch(function (error) {
        let errors = [];
        if (error.response.data.message != undefined) {
          if (error.response.data.message == 'Validation error') {
            errors.push(error.response.data.errors[0].msg);
          } else {
            errors.push(error.response.data.message);
          }
        } else {
          if (error.response.statusText != undefined)
            errors.push(error.response.statusText);
          if (error.error != undefined) errors.push(error.error);
        }
        responseData = { error: errors.join(',') };
      });

    return responseData;
  }
};

export default HTTPRequest;
